import { Box, SxProps, Theme } from '@mui/material'

export interface SignalLevelProps {
  min: number
  max: number
  level: number
  bad?: number
  good?: number
  disabled?: boolean
  sx?: SxProps<Theme>
}

/**
 * Display colored markers in line to present signal levels.
 */
export function SignalLevel(props: SignalLevelProps): React.ReactElement {

  const { min, max, level, bad, good, sx, disabled } = props
  const colors = []
  for (let i = min; i <= max; i++) {
    if (disabled) {
      colors.push('gray')
      continue
    }
    if (bad === undefined && good === undefined) {
      colors.push('secondary.main')
    } else {
      if (bad !== undefined && i <= bad) {
        colors.push('red')
      } else if (good !== undefined && i >= good) {
        colors.push('green')
      } else {
        colors.push('yellow')
      }
    }
  }
  return (
    <Box sx={{ ...sx, overflowX: 'visible', display: 'flex' }}>
      {colors.map((color, idx) => <Box key={idx} sx={{
        mr: '2px',
        width: (90 / (max - min + 1)) + '%',
        height: '1.2rem',
        opacity: !disabled && (idx + min <= level) ? 1 : 0.1,
        backgroundColor: color,
        display: 'inline-block',
        textAlign: 'center',
        fontSize: '0.5rem',
        fontWeight: 'bold',
        lineHeight: '1rem',
        color: 'black',
        borderTop: '2px solid rgba(255,255,255,0.2)',
        borderBottom: '1px solid rgba(0,0,0,0.3)',

      }}>&nbsp;</Box>)}
    </Box>
  )
}
